import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '../constants/constants';
import { isArrayNotEmpty } from '../helpers/utils';


@Pipe({
    name: 'commaSepName'
})
export class CommaSepNamePipe implements PipeTransform {

    constructor() { }
    transform(arr: { name: string }[], type = 'guest'): string {
        const nameArr = [];
        if (isArrayNotEmpty(arr) && type === 'guest') {
            const arrLen = arr.length;
            const extraGuest = arrLen - CONSTANTS.DISPLAY_GUEST_NO;
            if (extraGuest < 1) {
                return;
            }
            for (var i = arrLen - 1; i >= CONSTANTS.DISPLAY_GUEST_NO; i--) {
                nameArr.push(arr[i].name);
            }
        }
        else if (isArrayNotEmpty(arr)) {
            arr.forEach((e, i) => {
                if (i > 0) {
                    nameArr.push(e.name)
                }
            })
        }
        return nameArr.join(", ");
    }
}